import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        email: "",
        auth: "",
        user: null,
        articles: null,
        openPositions: null,
        positions: null,
        suppliers: null,
        tenders: null,
        elprocsy: null,
        articleFilter: null,
        positionsFilter: null,
        selectedArticles: [],
        startDate: null,
        endDate: null,
        optimizations: null,
        selectedOptimization: null,
        elprocsyShoppingCart: null,
        loading: false
    },
    mutations: {
        setAuth (state, auth) {
            state.auth = auth;
        },
        setEmail (state, email) {
            state.email = email;
        },
        setUser (state, user) {
            state.user = user;
        },
        setArticles (state, articles) {
            state.articles = articles;
        },
        setOpenPositions (state, openPositions) {
            state.openPositions = openPositions;
        },
        setPositions (state, positions) {
            state.positions = positions;
        },
        setPositionsFilter ( state, positionsFilter) {
            state.positionsFilter = positionsFilter;
        },
        setStartDate (state, startDate) {
            state.startDate = startDate;
        },
        setEndDate (state, endDate) {
            state.endDate = endDate;
        },
        setSuppliers (state, suppliers) {
            state.suppliers = suppliers;
        },
        setArticleFilter (state, articleFilter) {
            state.articleFilter = articleFilter;
        },
        setSelectedArticles (state, selectedArticles) {
            state.selectedArticles = selectedArticles;
        },
        setTenders (state, tenders) {
            state.tenders = tenders;
        },
        setElprocsy (state, elprocsy) {
            state.elprocsy = elprocsy;
        },
        setOptimizations (state, optimizations) {
            state.optimizations = optimizations;
        },
        setSelectedOptimization (state, optimization) {
            state.selectedOptimization = optimization;
        },
        setElProcSyShoppingCart (state, elprocsyShoppingCart) {
            state.elprocsyShoppingCart = elprocsyShoppingCart;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        logout (state) {
            state.email = "";
            state.auth = "";
            state.user = null;
            state.articles = null;
            state.openPositions = null;
            state.positions = null;
            state.suppliers = null;
            state.tenders = null;
            state.elprocsy = null;
            state.articleFilter = null;
            state.positionsFilter = null;
            state.selectedArticles = [];
            state.startDate = null;
            state.endDate = null;
            state.optimizations = null;
            state.selectedOptimization = null;
            state.elprocsyShoppingCart = null;
            state.loading = false;
            localStorage.removeItem("email");
            localStorage.removeItem("auth");
            localStorage.removeItem("user");
        }
    }
});
